type Game10Map = {
  intro: string[]
  items: Array<{
    id: number
    label: string
    img: string
    comment: string
  }>
}

export const Game10Map: Game10Map = {
  intro: [
    'Lesu běží čas pomaleji než nám lidem – než ze semínka vyrostou dospělé stromy, z nichž je možné vyrobit stůl nebo postavit dům, uběhne více než 100 let.',
    'Dokážeš za sebou seřadit obrázky tak, aby správně zobrazovaly cestu od semínka po výrobek?',
  ],
  items: [
    {
      id: 0,
      label: 'Semínko',
      img: require('../assets/game10/01_seminko-min.jpg').default,
      comment: 'Semínkem to začíná. Je první fází růstu nového lesa.',
    },
    {
      id: 1,
      label: 'Semenáček',
      img: require('../assets/game10/02_semenacek.jpg').default,
      comment:
        'Ze semínka vyroste semenáček. Aby se na pasece  konkurenci trav a ostatních stromků uchytil, musí v lesní půdě dobře zakořenit.',
    },
    {
      id: 2,
      label: 'Ochrana před zvěří',
      img: require('../assets/game10/02_ochrana-pred-zveri-min.jpg').default,
      comment:
        'Stromky, které ze semínek vyrostou, je potřeba chránit, aby je nemohla okusovat například srnčí zvěř. Proto se na ně nasazují ochranné obaly.',
    },
    {
      id: 3,
      label: 'Prořezávka',
      img: require('../assets/game10/03_prorezavka-min.jpg').default,
      comment:
        'Les je třeba vychovávat a s jeho výchovou se musí začít včas. Z mladého lesa se vyřezávají nemocné a poškozené stromky.',
    },
    {
      id: 4,
      label: 'Odrůstání lesa',
      img: require('../assets/game10/04_mlazina-min.jpg').default,
      comment:
        'Prořezaný a vychovaný les pak dobře roste. K růstovým fázím lesa patří stadium mlaziny (10-20 let), tyčkoviny (20-40 let) a tyčoviny (40-60 let).',
    },
    {
      id: 5,
      label: 'Probírka',
      img: require('../assets/game10/05_probirka-min.jpg').default,
      comment:
        'Kolem 50. roku věku lesa lesníci opět zasahují. I během probírky z lesa odstraňují nemocné stromy. A také ty, které ostatním brání v růstu.',
    },
    {
      id: 6,
      label: 'Těžba',
      img: require('../assets/game10/06_tezba-min.jpg').default,
      comment:
        'Když lesu táhne na 90 nebo 100 let, začnou v něm dřevorubci těžit stromy. Na uvolněných pasekách pak lesníci vysazují nový les.',
    },
    {
      id: 7,
      label: 'Odvoz dříví',
      img: require('../assets/game10/07_odvoz-drivi-min.jpg').default,
      comment:
        'Vytěžené dříví se za pomoci odvozních strojů odváží ke zpracování - na pilu, do dýhárny, do celulózky, podle požadavků zákazníka.',
    },
    {
      id: 8,
      label: 'Výrobky ze dřeva',
      img: require('../assets/game10/08_vyrobky-min.jpg').default,
      comment:
        'Dřevo je užitečný materiál šetrný k životnímu prostředí. Provází nás celý život. Po vykácení zpravidla následuje zalesnění. Rozhlédni se. Co všechno kolem tebe je vyrobeno ze dřeva?',
    },
  ],
}
